export default "__VITE_ASSET__C65$J72a__"